import { v4 as uuidv4 } from 'uuid';

export default {
	data() {
		return {
			componentUniqueId: uuidv4()
		};
	},
	// created() {
	// 	this.componentUniqueId = uuidv4();
	// }
};
